<!-- 申请管理 - 备案申请 - 受理/详情弹框 -->
<template>
    <custom-modal
        width="80%"
        :title="modalTitle"
        :visible="visible"
        :footer="modalFooter"
        class="filling-application-modal"
        @on-close="handleClose"
    >
        <modal-content
            :record="record"
            :is-detail-modal="isDetailModal"
            @on-after-confirm="handleAfterConfirm"
        />

        <template slot="customFooter">
            <custom-portal-target :name="portalTarget" />
        </template>
    </custom-modal>
</template>
<script>
import CustomModal from '@components/CustomModal'
import CustomPortalTarget from '@components/CustomPortalVue/PortalTarget'

import ModalContent, { PORTAL_KEY } from './Content'

import { FILLING_APPLY_STATE_APPLING } from '@constant/enum'

export default {
    name: 'FillingApplicationModal',
    components: {
        CustomModal,
        ModalContent,
        CustomPortalTarget
    },
    props: {
        record: {
            type: Object,
            required: true
        },
        visible: Boolean,
        isDetailModal: Boolean
    },
    data() {
        return {
            portalTarget: PORTAL_KEY
        }
    },
    computed: {
        // 备案申请状态是否为申请中
        isApplingState() {
            return this.record?.applyState === FILLING_APPLY_STATE_APPLING
        },
        // 弹框标题
        modalTitle() {
            return `备案申请${this.isDetailModal ? '详情' : '受理'}`
        },
        // 当备案申请状态为申请中时，才有 footer
        modalFooter() {
            return this.isApplingState ? undefined : null
        }
    },
    methods: {
        handleClose() {
            this.$emit('on-close')
        },
        handleAfterConfirm() {
            this.handleClose()
            this.$emit('on-ok')
        }
    }
}
</script>
<style lang="scss">
@import '@assets/styles/varibles.scss';

.filling-application-modal {
    .ant-card {
        &.has-margin-top {
            margin-top: $space-sm;
        }

        .ant-card-head-title {
            font-size: 14px;
        }
    }

    .ant-modal-body {
        padding-top: $space-sm;
    }
}
</style>
